/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplicationScope,
  DatabaseContentPage,
  SetContentPageWriteProtectionRequest,
  TransitionDatabaseRequest,
} from '../models';
import {
    ApplicationScopeFromJSON,
    ApplicationScopeToJSON,
    DatabaseContentPageFromJSON,
    DatabaseContentPageToJSON,
    SetContentPageWriteProtectionRequestFromJSON,
    SetContentPageWriteProtectionRequestToJSON,
    TransitionDatabaseRequestFromJSON,
    TransitionDatabaseRequestToJSON,
} from '../models';

export interface SetContentPageWriteProtectionOperationRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    contentPageName: string;
    setContentPageWriteProtectionRequest?: SetContentPageWriteProtectionRequest;
}

export interface TransitionDatabaseOperationRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    transitionDatabaseRequest?: TransitionDatabaseRequest;
}

/**
 * 
 */
export class DatabaseSpecialOpsControllerApi extends runtime.BaseAPI {

    /**
     * set write protection for a content page
     */
    async setContentPageWriteProtectionRaw(requestParameters: SetContentPageWriteProtectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseContentPage>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling setContentPageWriteProtection.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling setContentPageWriteProtection.');
        }

        if (requestParameters.contentPageName === null || requestParameters.contentPageName === undefined) {
            throw new runtime.RequiredError('contentPageName','Required parameter requestParameters.contentPageName was null or undefined when calling setContentPageWriteProtection.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-special-ops/{databaseId}/content-pages/{contentPageName}/set-write-protection`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"contentPageName"}}`, encodeURIComponent(String(requestParameters.contentPageName))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetContentPageWriteProtectionRequestToJSON(requestParameters.setContentPageWriteProtectionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseContentPageFromJSON(jsonValue));
    }

    /**
     * set write protection for a content page
     */
    async setContentPageWriteProtection(requestParameters: SetContentPageWriteProtectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseContentPage> {
        const response = await this.setContentPageWriteProtectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * transition database to new user
     * transition database to new user
     */
    async transitionDatabaseRaw(requestParameters: TransitionDatabaseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling transitionDatabase.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling transitionDatabase.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-special-ops/{databaseId}/transition`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TransitionDatabaseRequestToJSON(requestParameters.transitionDatabaseRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * transition database to new user
     * transition database to new user
     */
    async transitionDatabase(requestParameters: TransitionDatabaseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.transitionDatabaseRaw(requestParameters, initOverrides);
    }

}
